module.exports = __webpack_public_path__ + "static/media/icon-prize-blue.923ddc6f.svg";